import { Check, X } from "lucide-react";

interface SuccessIndicatorProps {
  label: string;
  value?: boolean;
}

export function SuccessIndicator({ label, value }: SuccessIndicatorProps) {
  if (value === undefined) {
    return (
      <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
        <span className="text-sm text-gray-600">{label}</span>
        <span className="text-xs text-gray-400">N/A</span>
      </div>
    );
  }

  return (
    <div
      className={`flex items-center justify-between p-3 rounded-lg ${
        value
          ? "bg-green-50 border border-green-200"
          : "bg-red-50 border border-red-200"
      }`}
    >
      <span className="text-sm font-medium text-gray-700">{label}</span>
      {value ? (
        <Check className="h-5 w-5 text-green-600" />
      ) : (
        <X className="h-5 w-5 text-red-600" />
      )}
    </div>
  );
}
